import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type ReportsPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const reportsIssueViewPageEntryPoint: EntryPoint<ReportsPageEntryPointComponent, {}> = {
	root: JSResourceForUserVisible<ReportsPageEntryPointComponent>(
		/* webpackChunkName: "async-csm-reports-issue-view-entrypoint" */
		'./ReportsIssueViewPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
};
